/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandAccessDtoFromJSON, BrandAccessDtoToJSON, } from './BrandAccessDto.js';
/**
 * Check if a given object implements the CreateUserAccessDto interface.
 */
export function instanceOfCreateUserAccessDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('brandAccess' in value) || value['brandAccess'] === undefined)
        return false;
    return true;
}
export function CreateUserAccessDtoFromJSON(json) {
    return CreateUserAccessDtoFromJSONTyped(json, false);
}
export function CreateUserAccessDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'brandAccess': BrandAccessDtoFromJSON(json['brandAccess']),
    };
}
export function CreateUserAccessDtoToJSON(json) {
    return CreateUserAccessDtoToJSONTyped(json, false);
}
export function CreateUserAccessDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'brandAccess': BrandAccessDtoToJSON(value['brandAccess']),
    };
}
//# sourceMappingURL=CreateUserAccessDto.js.map